import { Component } from '@angular/core';
import { TableModule } from "primeng/table";
import { FileUpload } from 'primeng/fileupload';
import { Button } from '../../Components/button/button';
import * as XLSX from 'xlsx';
import {OrderService} from '../order-service';
import {SpinnerOverlayService} from '../../Components/spinner/spinner-overlay.service';
import {Router} from '@angular/router';
import {MessageService} from '../../shared/message.service';
import {AccountService} from '../../login/account.service';
import {Toast} from 'primeng/toast';
@Component({
  selector: 'app-massive-load',
  imports: [
    Button,
    TableModule,
    FileUpload,
    Toast
  ],
  templateUrl: './massive-load.component.html',
  styleUrl: './massive-load.component.css',
})
export class MassiveLoadComponent {

  constructor(private spinner: SpinnerOverlayService,
              private router: Router,
              private orderService: OrderService,
              private messageService: MessageService,
              private accountService: AccountService) {
  }

  files: File[] = [];
  totalSize: number = 0;
  totalSizePercent: number = 0;

  selectedFile!: File;
  records: any[] = [];
  tableHeaders: string[] = [];

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: any) {
    this.files = event.currentFiles;
    this.selectedFile = this.files[0];
    this.totalSizePercent = this.totalSize / 10;
    this.records = [];
    this.tableHeaders = [];
  }

  processFile() {
    if (!this.selectedFile) return;

    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];

      this.formatExcelData(excelData);

      if (this.records.length > 0) {
        this.sendMassiveLoadToBackend();
      }
    };

    reader.readAsArrayBuffer(this.selectedFile);
  }


  formatExcelData(excelData: any[][]) {

    if (!excelData || excelData.length < 2) {
      this.messageService.showError(
        'Archivo vacío. El archivo debe contener encabezados y al menos una fila de datos.'
      );
      return;
    }

    const [headers, ...rows] = excelData;

    const codeIndex = headers.indexOf("Code");
    const cantIndex = headers.indexOf("Cant");

    if (codeIndex === -1 || cantIndex === -1) {
      this.messageService.showError(
        'Formato incorrecto. El archivo debe contener las columnas: Code y Cant'
      );
      return;
    }

    this.tableHeaders = ["Code", "Cant"];

    this.records = rows
      .map(row => ({
        Code: row[codeIndex] ?? null,
        Cant: row[cantIndex] ?? null
      }))
      .filter(item =>
        item.Code !== null &&
        item.Code !== "" &&
        item.Cant !== null &&
        item.Cant !== "" &&
        !isNaN(Number(item.Cant))
      );

    if (this.records.length === 0) {
      this.messageService.showError(
        'No hay registros válidos para procesar.'
      );
      return;
    }

    console.log("Registros filtrados:", this.records);
  }



  handleLoading(loading: boolean) {
    if (loading) this.spinner.show(); else this.spinner.hide()
  }

  sendMassiveLoadToBackend() {
    if (this.records.length === 0) return;

    this.handleLoading(true);

    const items = this.records.map(r => ({
      code: r.Code,
      cant: r.Cant
    }));

    const dto = {
      itemMassiveDTOList: items,
      userID: this.accountService.userIdentity()?.user.id,
      addressNumber: this.accountService.userIdentity()?.user.addressNumber,
    };


    this.orderService.massiveLoad(dto).subscribe({
      next: (resp: any) => {
        console.log("Respuesta backend:", resp);

        const orderId = resp?.body?.orderId;
        if (orderId) this.viewOrderItems(orderId);

        this.messageService.showSuccess('Pedido guardado con éxito como borrador');

        this.handleLoading(false);
      },
      error: (err) => {
        console.error("Error al enviar:", err);
        this.handleLoading(false);
        
        // Extract and format validation error messages
        const errorMessage = this.extractValidationErrors(err);
        this.messageService.showError(errorMessage);
      }
    });
  }



  viewOrderItems(orderId: string | number) {
    if (!orderId) return;

    this.handleLoading(true);
    const addressNumber = this.accountService.userIdentity()?.user.addressNumber;

    this.orderService.getOrderItems(String(orderId), addressNumber, addressNumber).subscribe({
      next: (response: any) => {
        try {
          const itemsArray = response?.body?.items ?? response?.items ?? response;
          localStorage.setItem('orderId', String(orderId));
          localStorage.setItem('my_cart_items', JSON.stringify(itemsArray));
        } catch (e) {
          console.error('Failed to save order items to localStorage', e);
        }
        this.handleLoading(false);
        this.router.navigate(['/home/pedidos/crear/confirmar-pedido']);
      },
      error: () => {
        this.handleLoading(false);
      }
    })
  }

  extractValidationErrors(err: any): string {
    // Try to get the error message from different possible locations
    const rawMessage = err?.error?.reason || err?.error?.message || err?.message || 'Error al procesar el archivo';
    
    console.log('Raw error message:', rawMessage);
    
    // Check if it's a validation error
    if (rawMessage.includes('Validation failed')) {
      // Extract item codes from the error message
      const itemCodes = this.extractItemCodes(rawMessage);
      
      if (itemCodes.length > 0) {
        const uniqueCodes = [...new Set(itemCodes)];
        
        if (uniqueCodes.length === 1) {
          return `El producto con código ${uniqueCodes[0]} no se encuentra disponible.`;
        } else if (uniqueCodes.length <= 3) {
            return `Los productos con códigos ${uniqueCodes.join(', ')} no se encuentran disponibles.`;
          } else {
          return `${uniqueCodes.length} productos no se encuentran disponibles: ${uniqueCodes.slice(0, 5).join(', ')}${uniqueCodes.length > 5 ? '...' : ''}.`;
        }
      }
      
      // If we can't extract item codes, show a generic validation message
      return 'Algunos productos no están disponibles.';
    }
    
    // For non-validation errors, return the original message or a generic error
    return rawMessage || 'Error al procesar el archivo';
  }

  extractItemCodes(message: string): string[] {
    // Match patterns like "item AGLDHMC1684" or "item CODE123"
    const regex = /item\s+([A-Z0-9]+)/gi;
    const matches = message.matchAll(regex);
    const codes: string[] = [];
    
    for (const match of matches) {
      if (match[1]) {
        codes.push(match[1]);
      }
    }
    
    return codes;
  }

}
